/** An API response with a non-2xx status. Lives on its own so the app entry can use it without the API client. */
export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
  }
}
